module.exports = __webpack_public_path__ + "img/login-footer.afe44859.jpg";